module.exports = __webpack_public_path__ + "img/Get-In-The-Game.0018d981.png";